<template>
  <section>
    <!--工具条-->
    <Toolbar
      :buttonList="buttonList"
      @callFunction="callFunction"
      :selectBut="false"
    ></Toolbar>

    <!--列表-->
    <el-table
      ref="listTable"
      :data="list"
      highlight-current-row
      v-loading="listLoading"
      @current-change="selectCurrentRow"
      style="width: 100%"
      :height="getTableHeight(165)"
    >
      <el-table-column
        prop="Sort"
        :label="$t('Sort')"
        width="50"
      ></el-table-column>
      <el-table-column :label="$t('Cover')" width="100">
        <template slot-scope="scope">
          <div
            v-if="scope.row.Cover != null && scope.row.Cover != ''"
            class="coverimg"
            :style="{
              backgroundImage: 'url(' + baseCoverUrl + scope.row.Cover + ')',
            }"
          ></div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('Name')">
        <template slot-scope="scope">
          <i class="fa" :class="scope.row.Icon"></i>
          {{ field(scope.row.Name) }}
        </template>
      </el-table-column>
      <el-table-column prop="Remark" :label="$t('Remark')"></el-table-column>
      <el-table-column prop="Enabled" :label="$t('Enabled')" width="100">
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.Enabled ? 'success' : 'danger'"
            disable-transitions
            >{{ scope.row.Enabled ? $t("enabled") : $t("disable") }}</el-tag
          >
        </template>
      </el-table-column>
    </el-table>

    <!--编辑界面-->
    <el-dialog
      :title="$t('edit')"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="editForm" label-width="80px" ref="editForm">
        <LangTabs>
          <template v-slot:main="slot">
            <el-form-item label="排序" prop="Sort">
              <el-input
                v-model.number="editForm.Sort"
                type="text"
                maxlength="4"
                style="width: 150px"
              ></el-input>
            </el-form-item>
            <el-form-item
              :label="$t('Name')"
              :prop="'Name.' + slot.langkey"
              :rules="{
                required: true,
                message: $t('pleaseEnter') + $t('Name'),
              }"
            >
              <el-input v-model="editForm.Name[slot.langkey]"></el-input>
            </el-form-item>
            <el-form-item :label="$t('Cover')">
              <div class="upload-img-form">
                <el-upload
                  class="upload-img"
                  :auto-upload="false"
                  action="xxx"
                  list-type="picture"
                  :show-file-list="false"
                  :on-change="uphandleChange"
                  :style="{
                    backgroundImage:
                      'url(' + baseEditCoverUrl + editForm.EditCover + ')',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center center',
                    backgroundSize: 'contain',
                  }"
                  accept="image/png, image/gif, image/jpg, image/jpeg"
                >
                  <i
                    v-show="!editForm.EditCover"
                    class="el-icon-upload avatar-uploader-icon"
                  ></i>
                  <i
                    v-show="editForm.EditCover"
                    class="el-icon-refresh avatar-uploader-icon"
                  ></i>
                  <div
                    v-show="!editForm.EditCover"
                    slot="tip"
                    class="el-upload__text upload__tip"
                  >
                    {{ $t("uploadImgLabel") }}
                  </div>
                  <div
                    v-show="editForm.EditCover"
                    slot="tip"
                    class="el-upload__text upload__tip"
                  >
                    {{ $t("uploadChoose") }}
                  </div>
                </el-upload>
              </div>
            </el-form-item>
            <el-form-item :label="$t('Remark')">
              <el-input
                type="textarea"
                :rows="2"
                v-model="editForm.Remark"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('Enabled')">
              <el-switch v-model="editForm.Enabled"></el-switch>
            </el-form-item>
          </template>
          <template v-slot:other="slot">
            <el-form-item :label="$t('Name')">
              <el-input v-model="editForm.Name[slot.item.key]"></el-input>
            </el-form-item>
          </template>
        </LangTabs>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">{{
          $t("cancel")
        }}</el-button>
        <el-button
          type="primary"
          @click.native="editSubmit"
          :loading="editLoading"
          >{{ $t("submit") }}</el-button
        >
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog
      :title="$t('add')"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="addForm" label-width="80px" ref="addForm">
        <LangTabs>
          <template v-slot:main="slot">
            <el-form-item label="排序" prop="Sort">
              <el-input
                v-model.number="addForm.Sort"
                type="text"
                maxlength="4"
                style="width: 150px"
              ></el-input>
            </el-form-item>
            <el-form-item
              :label="$t('Name')"
              :prop="'Name.' + slot.langkey"
              :rules="{
                required: true,
                message: $t('pleaseEnter') + $t('Name'),
              }"
            >
              <el-input v-model="addForm.Name[slot.langkey]"></el-input>
            </el-form-item>
            <el-form-item :label="$t('Cover')">
              <div class="upload-img-form">
                <el-upload
                  class="upload-img"
                  :auto-upload="false"
                  action="xxx"
                  list-type="picture"
                  :show-file-list="false"
                  :on-change="handleChange"
                  :style="{
                    backgroundImage: 'url(' + addForm.Cover + ')',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center center',
                    backgroundSize: 'contain',
                  }"
                  accept="image/png, image/gif, image/jpg, image/jpeg"
                >
                  <i
                    v-show="!addForm.Cover"
                    class="el-icon-upload avatar-uploader-icon"
                  ></i>
                  <i
                    v-show="addForm.Cover"
                    class="el-icon-refresh avatar-uploader-icon"
                  ></i>
                  <div
                    v-show="!addForm.Cover"
                    slot="tip"
                    class="el-upload__text upload__tip"
                  >
                    {{ $t("uploadImgLabel") }}
                  </div>
                  <div
                    v-show="addForm.Cover"
                    slot="tip"
                    class="el-upload__text upload__tip"
                  >
                    {{ $t("uploadChoose") }}
                  </div>
                </el-upload>
              </div>
            </el-form-item>
            <el-form-item :label="$t('Remark')">
              <el-input
                type="textarea"
                :rows="2"
                v-model="addForm.Remark"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('Enabled')">
              <el-switch v-model="addForm.Enabled"></el-switch>
            </el-form-item>
          </template>
          <template v-slot:other="slot">
            <el-form-item :label="$t('Name')">
              <el-input v-model="addForm.Name[slot.item.key]"></el-input>
            </el-form-item>
          </template>
        </LangTabs>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">{{
          $t("cancel")
        }}</el-button>
        <el-button
          type="primary"
          @click.native="addSubmit"
          :loading="addLoading"
          >{{ $t("submit") }}</el-button
        >
      </div>
    </el-dialog>
  </section>
</template>

<script>
import util from "util/date";
import {
  base,
  getShopTypeListPage,
  removeShopType,
  editShopType,
  addShopType,
} from "@/api/api";
import { getButtonList } from "@/promissionRouter";

export default {
  data() {
    return {
      filters: {
        Name: "",
      },
      buttonList: [],
      list: [],
      total: 0,
      page: 1,
      listLoading: false,
      baseCoverUrl: base + "/FileUpload/ShopTypeCover/a0/",
      baseEditCoverUrl: base + "/FileUpload/ShopTypeCover/a0/",
      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      //编辑界面数据
      editForm: { Name: {} },
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      //新增界面数据
      addForm: { Name: {} },
    };
  },
  methods: {
    formatDate: function (val) {
      return util.formatDate.format(new Date(val), "yyyy-MM-dd hh:mm");
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this.filters = {
        Name: item.search,
      };
      this[item.Func].apply(this, item);
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    //获取列表
    getList() {
      let para = {
        page: this.page,
      };
      this.listLoading = true;
      getShopTypeListPage(para).then((res) => {
        this.list = res.data.response;
        this.listLoading = false;
      });
    },
    // 图片预览
    uphandleChange(file) {
      this.baseEditCoverUrl = "";
      this.editForm.EditCover = file.url;
      this.getBase64(file.raw).then((res) => {
        this.editForm.CoverFile = res;
      });
    },
    // 图片预览
    handleChange(file) {
      this.addForm.Cover = file.url;
      this.getBase64(file.raw).then((res) => {
        this.addForm.CoverFile = res;
      });
    },
    //删除
    handleDel() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: this.$t("selectRow"),
          type: "error",
        });

        return;
      }
      this.$confirm(this.$t("deletePrompt"), this.$t("prompt"), {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          let para = { id: row.Id };
          removeShopType(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            if (res.data.success) {
              this.$message({
                message: this.$t("deleteSuccess"),
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.getList();
          });
        })
        .catch(() => {});
    },
    //显示编辑界面
    handleEdit() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: this.$t("selectRow"),
          type: "error",
        });

        return;
      }
      this.editFormVisible = true;
      this.editForm = Object.assign({}, this.clone(row));
      this.editForm.EditCover = this.editForm.Cover;
      this.editForm.CoverFile = null;
      this.baseEditCoverUrl = base + "/FileUpload/ShopTypeCover/a0/";
    },
    //显示新增界面
    handleAdd() {
      this.addFormVisible = true;
      this.addForm = {
        Name: {},
        Cover: null,
        CoverFile: null,
        Sort: 0,
        Remark: "",
        Enabled: true,
      };
    },
    //编辑
    editSubmit: function () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm(this.$t("submitPrompt"), this.$t("prompt"), {})
            .then(() => {
              this.editLoading = true;
              let para = Object.assign({}, this.editForm);

              editShopType(para).then((res) => {
                if (util.isEmt.format(res)) {
                  this.editLoading = false;
                  return;
                }
                if (res.data.success) {
                  this.editLoading = false;
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.$refs["editForm"].resetFields();
                  this.editFormVisible = false;
                  this.$refs.listTable.setCurrentRow();
                  this.getList();
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              });
            })
            .catch(() => {});
        }
      });
    },
    //新增
    addSubmit: function () {
      let _this = this;
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm(this.$t("submitPrompt"), this.$t("prompt"), {})
            .then(() => {
              this.addLoading = true;
              let para = Object.assign({}, this.addForm);
              para.IsDeleted = false;

              addShopType(para).then((res) => {
                if (util.isEmt.format(res)) {
                  this.addLoading = false;
                  return;
                }

                if (res.data.success) {
                  this.addLoading = false;
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.$refs["addForm"].resetFields();
                  this.addFormVisible = false;
                  this.getList();
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              });
            })
            .catch(() => {});
        }
      });
    },
  },
  mounted() {
    this.getList();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
</style>
